import { useQuery } from '@tanstack/react-query';

import { fetchNotifications } from '@/adapters/fetchExaCare';

interface SuprSendTokenPayload {
  token: string;
  expiresAt: number;
}

const QUERY_KEY: string[] = ['useSuprSendJwtTokenQuery'];

export const useSuprSendJwtToken = (userId?: string, tenantId?: string) => {
  return useQuery(
    [...QUERY_KEY, userId, tenantId],
    async () => {
      const response = await fetchNotifications.post<SuprSendTokenPayload>(
        `/suprsend/generate-jwt-token`,
        {
          user_id: userId,
          tenant_id: tenantId || 'default',
          expires_in: 3600 // 1 hour default
        }
      );

      return response;
    },
    {
      enabled: !!userId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000 // 10 minutes
    }
  );
};
